module.exports = __webpack_public_path__ + "img/logo_aurus.08db9c8e.svg";